import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61cf135c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: "/img/search_icon.svg",
  alt: "search_icon"
}
const _hoisted_2 = ["value", "placeholder"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/close_icon_white.svg",
  alt: "close_icon"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { computed, onMounted, Ref, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import EventEmitter from "@/utils/eventEmitter";
import SearchIcon from "@/components/svgs/searchIcon.vue";
import { IPlanDetails } from "@/interfaces/org/subscription";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'inputSearch',
  props: {
    isFocus: { type: Boolean },
    searchKey: {}
  },
  emits: ["focus", "close-menu", "change-search-key", "on-search"],
  setup(__props: any, { emit }) {

const props = __props;





const inputRef = ref<HTMLInputElement | null>(null);
const isTyping = ref(false);
let timeoutId: any | number | null = null;
const isSubscriptionsInvalid = ref(false);
const orgPlanDetails: Ref<IPlanDetails> = computed(
  () => store.getters["Org/getPlanDetails"],
);

watch(
  () => props.isFocus,
  () => {
    if (props.isFocus) {
      inputRef.value?.focus();
    } else {
      inputRef.value?.blur();
    }
  },
);

watch(
  () => orgPlanDetails.value,
  () => {
    if (!orgPlanDetails.value || !orgPlanDetails.value.planId) {
      isSubscriptionsInvalid.value = true;
    } else {
      isSubscriptionsInvalid.value = false;
    }
  },
);

onMounted(() => {
  setTimeout(() => {
    const cond = document.getElementById("pricing-table-container");
    if (cond) {
      isSubscriptionsInvalid.value = true;
    } else {
      isSubscriptionsInvalid.value = false;
    }
  }, 1000);
  if (props.isFocus) {
    inputRef.value?.focus();
  }
});

const onInput = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
  timeoutId = setTimeout(() => {
    if (isTyping.value) {
      emit("on-search");
    }
  }, 750);
};

const onClear = () => {
  isTyping.value = false;
  emit("change-search-key", "");
  inputRef.value?.focus();
};

const onSearch = () => {
  isTyping.value = false;
  emit("on-search");
  inputRef.value?.focus();
};

const onFocus = () => {
  emit("focus");
  EventEmitter.emit("active-org-dropDown-close-dropdown");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "menu-global-search",
    class: _normalizeClass(`global-search ${_ctx.isFocus ? 'global-search-focus' : ''} ${
      isSubscriptionsInvalid.value || !orgPlanDetails.value?.planId ? 'disabled' : ''
    }`),
    onKeyup: [
      _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('close-menu')), ["esc"])),
      _cache[3] || (_cache[3] = _withKeys(
      () => {
        isTyping.value = false;
        _ctx.$emit('on-search');
      }
    , ["enter"]))
    ]
  }, [
    (_ctx.isFocus)
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : (_openBlock(), _createBlock(SearchIcon, {
          key: 1,
          color: `#ffffff`,
          class: _normalizeClass(`tw-w-[12px] tw-h-[12px] icon-pointer-unset`)
        })),
    _createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      type: "text",
      value: _ctx.searchKey,
      placeholder: `${_unref(getComponentUiText)('app-header-search-prompt-1')}`,
      onInput: _cache[0] || (_cache[0] = 
        (e) => {
          isTyping.value = true;
          _ctx.$emit('change-search-key', e?.target.value);
          onInput();
        }
      ),
      onFocus: onFocus,
      onFocusout: _cache[1] || (_cache[1] = ($event: any) => (isTyping.value = false))
    }, null, 40, _hoisted_2),
    _withDirectives(_createElementVNode("button", { onClick: onClear }, _hoisted_4, 512), [
      [_vShow, !!_ctx.searchKey]
    ]),
    _withDirectives(_createElementVNode("span", { onClick: onSearch }, _toDisplayString(_unref(getComponentUiText)("app-header-search-button-search-label-1")), 513), [
      [_vShow, _ctx.isFocus]
    ])
  ], 34))
}
}

})